import React from 'react';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function CadastroDeCDRAdd() {
  return (
    <div>
      <ContainerSection>
        <h3>Cadastrar</h3>
        <div>
          <WrapperInputsNewSystem>
            <SelectAndOptions title="Empresa" id="Empresa" optionsArray={['']} widthPercentage="18%" />
            <SelectAndOptions title="Divisão" id="Divisao" optionsArray={['']} widthPercentage="18%" />
            <SelectAndOptions title="Área" id="Area" optionsArray={['']} widthPercentage="18%" />
            <SelectAndOptions title="Depto" id="Depto" optionsArray={['']} widthPercentage="18%" />
            <SelectAndOptions title="Produto/Serviço" id="ProdutoServico" optionsArray={['']} widthPercentage="18%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="CDR" id="CDR" widthPercentage="18%" />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error">Cancelar</button>
      </ButtonsGeneric>
    </div>
  );
}
